var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.098 2.11757C13.098 1.6844 12.7468 1.33325 12.3136 1.33325C11.8805 1.33325 11.5293 1.6844 11.5293 2.11757V2.90188H4.47051V2.11757C4.47051 1.6844 4.11936 1.33325 3.68619 1.33325C3.25303 1.33325 2.90188 1.6844 2.90188 2.11757V2.90188H2.11757C1.6844 2.90188 1.33325 3.25303 1.33325 3.68619V13.8823C1.33325 14.3154 1.6844 14.6666 2.11757 14.6666H13.8823C14.3154 14.6666 14.6666 14.3154 14.6666 13.8823V3.68619C14.6666 3.25303 14.3154 2.90188 13.8823 2.90188H13.098V2.11757ZM2.90188 13.098V6.82345H13.098V13.098H2.90188Z","fill":"white"}));
}

Calendar.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
